import WebsiteBehaviors from "../website-behaviors/index.js";

class IEEExplore extends WebsiteBehaviors {
	identifier() {
		return "IEEExplore";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "ieeexplore.ieee.org";
	}

	static isPDF() {
		return true;
	}

	shouldFrameTakeControl() {
		return true;
	}
}

export default IEEExplore;
